import Yup from "../../Yup";
import { email } from "../../helpers/formSchemaHelper";

const RequestPasswordSchema = Yup.object().shape({
  email: email,
});

export default RequestPasswordSchema;
